/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Builders_DetailInputs */

const en_common_header_explore_builders_detail = /** @type {(inputs: Common_Header_Explore_Builders_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet the makers`)
};

const zh_common_header_explore_builders_detail = /** @type {(inputs: Common_Header_Explore_Builders_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认识创作者`)
};

/**
* | output |
* | --- |
* | "Meet the makers" |
*
* @param {Common_Header_Explore_Builders_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_builders_detail = /** @type {((inputs?: Common_Header_Explore_Builders_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Builders_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_builders_detail(inputs)
	return zh_common_header_explore_builders_detail(inputs)
});
export { common_header_explore_builders_detail as "common.header.explore.builders.detail" }